import React from "react";
import * as yup from "yup";

export const COURIER_COST_PERMISSION = "Courier Service Costs";

export const filterSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

// Numeric money/percent field: empty input is "required", not "must be a number".
export const rateField = (label) =>
  yup
    .number()
    .transform((value, original) => (original === "" || original === null ? undefined : value))
    .typeError(`${label} must be a number`)
    .min(0, `${label} cannot be negative`)
    .required(`You must enter the ${label.toLowerCase()}`);

export const RateInfoNote = ({ children }) => (
  <small className="text-muted d-block">
    <i className="fa fa-info-circle mr-1"></i>
    {children}
  </small>
);

export const NEW_ORDERS_ONLY_NOTE = "Changes apply to new orders only; existing orders keep the cost recorded when they were processed.";
